<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Empresa"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <raht-empresa-form
            tipo="A"
            :mostrarModal="mostrarModal"
            :empresa="empresa"
            @modalFechado="mostrarModal = false"
            @atualizarEmpresa="$emit('atualizarEmpresa', $event)"
        ></raht-empresa-form>
        <!-- <dotacao-form
            :mostrarModal="mostrarModal"
            @modalFechado="mostrarModal = false"
            :valorTotal="valorTotal"
            :valorDisponivel="valorDisponivel"
            tipo="A"
            :rateio="rateio"
            @atualizarRateio="$emit('atualizarRateio', $event)"
        ></dotacao-form> -->
    </div>
</template>

<script>
import RahtEmpresaForm from './RahtEmpresaForm'

export default {
    components: {
        RahtEmpresaForm
    },

    props: {
        empresa: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            mostrarModal: false
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
